import FundingRedesignDescriptor from './funding-redesign';
import FundingRefiveDescriptor from './funding-refive';
import FundingCompanyKitchenDescriptor from './funding-companykitchen';
import BuildTypes from 'src/constants/BuildTypeConstants';
import Settings from 'src/Settings';

const typeDescriber = {
  [BuildTypes.canteen]: FundingRedesignDescriptor,
  [BuildTypes.default]: FundingRedesignDescriptor,
  [BuildTypes.companykitchen]: FundingCompanyKitchenDescriptor,
  [BuildTypes.refive]: FundingRefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}

export interface FundingDescriberProps {
  close: () => void;
}
